import { useCallback, useState } from 'react';

export function useSearchTriggerKeyword(hotKeyword: string, lastSearchKeyword: string) {
    const [entryHotKeyword, setEntryHotKeyword] = useState<string>();

    const recordEntryHotKeyword = useCallback(() => {
        setEntryHotKeyword(hotKeyword);
    }, [hotKeyword]);

    const isShowingHotKeyword =
        !lastSearchKeyword ||
        (entryHotKeyword !== undefined && lastSearchKeyword === entryHotKeyword);

    return {
        displayKeyword: isShowingHotKeyword ? hotKeyword : lastSearchKeyword,
        isShowingHotKeyword,
        recordEntryHotKeyword,
    };
}
